import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthenticationProvider } from '../../context/AuthenticationContext';
import { ProjectProvider } from '../../project-details/context/ProjectContext';
import SaveSealDropdown from './SaveSealDropdown';
import ToastNotification from '../../components/toast/ToastNotification';

const $root: HTMLElement | null = document.getElementById(
	'save-seal-to-project'
);

if ($root) {
	const brand = $root.dataset.brand ?? '';
	const housingBore = $root.dataset.housingBore ?? '';
	const material = $root.dataset.material ?? '';
	const sealPartDescription = $root.dataset.sealPartDescription ?? '';
	const sealPartImageUrl = $root.dataset.sealPartImageUrl ?? '';
	const sealPartNumber = $root.dataset.sealPartNumber ?? '';
	const shaftDiameter = $root.dataset.shaftDiameter ?? '';
	const type = $root.dataset.type ?? '';
	const width = $root.dataset.width ?? '';

	ReactDOM.createRoot($root).render(
		<React.StrictMode>
			<AuthenticationProvider>
				<ProjectProvider>
					<SaveSealDropdown {...{
						brand,
						housingBore,
						material,
						sealPartDescription,
						sealPartImageUrl,
						sealPartNumber,
						shaftDiameter,
						type,
						width,
					}} />

					<ToastNotification/>
				</ProjectProvider>
			</AuthenticationProvider>
		</React.StrictMode>
	);
}
